import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { Rocket } from "lucide-react";
export default function LaunchYourProductWithConfidence() {
  return <section className="relative py-16 px-6 lg:px-8 bg-background overflow-hidden">
      {}
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_30%_20%,oklch(0.34_0.09_230/0.05),transparent_50%)]" />
      
      <div className="relative max-w-7xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-12 items-center">
          {}
          <div className="lg:col-span-7 space-y-6 animate-fade-in-up">
            <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-accent/10 text-accent border border-accent/20">
              <Rocket className="size-4" />
              <span className="text-sm font-semibold">Product Launch & Roadmap</span>
            </div>
            
            <h1 className="text-4xl lg:text-5xl font-bold text-foreground leading-tight">
              Launch Your Product with Confidence
            </h1>
            
            <p className="text-lg text-muted-foreground leading-relaxed max-w-2xl">
              Transform your idea into a successful product launch with Aran Group's comprehensive approach. 
              We guide you through every step—from product strategy and vendor sourcing to timeline management, 
              technical setup, and ongoing support—ensuring a seamless journey from concept to market.
            </p>
            
            <div className="flex flex-wrap gap-4 pt-4">
              <Link to="/ProductLaunchRoadmapPage">
                <Button size="lg" className="shadow-medium hover-lift">
                  Learn More
                </Button>
              </Link>
              
              <Link to="/ContactPage">
                <Button size="lg" variant="outline" className="hover-lift">
                  Get Started
                </Button>
              </Link>
            </div>
          </div>
          
          {}
          <div className="lg:col-span-5 relative">
            <div className="relative rounded-lg overflow-hidden shadow-strong hover-lift">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1399276/img/product_launch_roadmap_hero.png" alt="Product launch planning" className="w-full h-auto object-cover" />
              <div className="absolute inset-0 bg-gradient-to-t from-primary/20 to-transparent" />
            </div>
            
            {}
            <div className="absolute -bottom-6 -left-6 lg:-left-8 bg-background rounded-lg shadow-medium p-4 border border-border max-w-xs hover-lift">
              <div className="flex items-start gap-3">
                <div className="size-10 rounded-full bg-accent/10 flex items-center justify-center shrink-0">
                  <Rocket className="size-5 text-accent" />
                </div>
                <div>
                  <p className="text-sm font-semibold text-foreground">End-to-End Support</p>
                  <p className="text-xs text-muted-foreground mt-1">From strategy to launch and beyond</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}